import { Injectable } from '@angular/core';
import { Enumeracao } from '../models/enumeracao';
import { Observable } from 'rxjs/Rx';

@Injectable({
  providedIn: 'root'
})
export class EnumService {

  // seeds
  sexos: Enumeracao[] = [
    { Key: 'Feminino', Value: '0' },
    { Key: 'Masculino', Value: '1' }
  ];

  tiposDePessoa: Enumeracao[] = [
    { Key: 'Física', Value: '0' },
    { Key: 'Jurídica', Value: '1' }
  ];

  estadosCivis: Enumeracao[] = [
    { Key: 'Solteiro', Value: '0' },
    { Key: 'Casado', Value: '1' },
    { Key: 'Separado', Value: '2' },
    { Key: 'Divorciado', Value: '3' },
    { Key: 'Viúvo', Value: '4' }
  ];

  tiposDePessoaJuridica: Enumeracao[] = [
    { Key: 'D. P. Externo', Value: '0' },
    { Key: 'D. P. Interno', Value: '1' },
    { Key: 'D. P. Privado', Value: '2' }
  ];

  constructor() { }

  consultarSexos() {
    return Observable.of(new Object()).mapTo(this.sexos);
  }

  consultarTiposDePessoa() {
    return Observable.of(new Object()).mapTo(this.tiposDePessoa);
  }

  consultarEstadosCivis() {
    return Observable.of(new Object()).mapTo(this.estadosCivis);
  }

  consultarTiposDePessoaJuridica() {
    return Observable.of(new Object()).mapTo(this.tiposDePessoaJuridica);
  }
}
